import {
  Component,
  Inject,
  OnInit,
  ElementRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
} from '@angular/material/dialog';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { FeatureToggleService } from '@core/services/feature-toggle/feature-toggle.service';
import { Observable } from 'rxjs';
import { IProjectsListingVM } from '@core/state/entities/project/project-summary.viewmodel';
import { map } from 'rxjs';
import { selectProjectListingsAreLoading } from '@core/state/ui/project-index/project-index-ui.selectors';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { selectProjectListings } from '@core/state/entities/project/project-summary.viewmodel.selectors';
import { AsyncPipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@Component({
  selector: 'app-project-summary-modal',
  templateUrl: './project-summary-modal.component.html',
  styleUrls: ['./project-summary-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogContent,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    MatDialogActions,
    MatButtonModule,
    MatDialogClose,
    MatIconModule,
    MatDialogTitle,
    MatStepperModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    AsyncPipe,
  ],
})
export class ProjectSummaryModalComponent implements OnInit {
  comment: UntypedFormGroup;
  @ViewChild('backButton') button: ElementRef;
  showBackButton: boolean;
  project$: Observable<IProjectsListingVM | undefined>;
  projectLoading$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    public _dialogRef: MatDialogRef<ProjectSummaryModalComponent>,
    private _store: Store,
    private _router: Router,
    private _fb: UntypedFormBuilder,
    public featureToggleService: FeatureToggleService
  ) {
    this.project$ = this._store
      .select(selectProjectListings)
      .pipe(
        map((pros): IProjectsListingVM | undefined =>
          pros.find((pro) => pro.id === data)
        )
      );

    this.projectLoading$ = this._store.select(selectProjectListingsAreLoading);

    this.comment = this._fb.group({
      commentContent: '',
    });
    this.showBackButton = false;
  }

  ngOnInit(): void {}

  onRegister(projectId) {
    this._store.dispatch(
      projectDetailActions.register({
        projectId,
        requestMessage: this.comment.value || null,
      })
    );
  }

  onNavigate(projectId) {
    this._dialogRef.close(true);
    this._router.navigate(['projects', projectId, 'detail']);
  }

  showButton() {
    this.showBackButton = true;
  }

  goBack() {
    this.button.nativeElement.click();
    this.showBackButton = false;
  }
}
